// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"0c7bbe4a","100":"dc0b4c6c","203":"68c26a2e","239":"dac06248","329":"60f74e17","389":"59ca09a1","453":"f88409ed","455":"7ac8d574","821":"2b5cc8e9","972":"659422c1","977":"e9d662d1"}[chunkId] + ".chunk.js";
};